export default __webpack_public_path__ + "static/retreat_11-bb6b1e20e7aae25faef77ed775c1fa1b.jpg";